import { useRef } from 'react';
import { useUnmount } from 'ahooks';

export default function useSafeTimerRef(clear: (timerId: NodeJS.Timeout) => void) {
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  const handleClearTimer = () => {
    if (timerRef.current) {
      clear(timerRef.current);
      timerRef.current = null;
    }
  };

  // 组件卸载时清除定时器，避免对已卸载组件 setState
  useUnmount(() => {
    handleClearTimer();
  });

  return { timerRef, clearTimer: handleClearTimer };
}
